<template>
  <el-form
    :model="form"
    class="m-form"
    label-width="100px"
    label-position="top"
    :rules="rules"
    ref="form"
  >
    <el-form-item
      :label="$t('common.old_pwd_label')"
      prop="oldPwd"
      v-if="showOldPwd"
    >
      <el-input
        :type="passwordType"
        onpaste="return false"
        oncontextmenu="return false"
        oncopy="return false"
        oncut="return false"
        v-model="form.oldPwd"
      >
        <!-- <i
          slot="suffix"
          class="el-input__icon"
          :class="passwordIcon"
          @mousedown="onMousedownClick"
          @mouseup="onMouseupClick"
        ></i> -->
      </el-input>
    </el-form-item>
    <el-form-item
      :label="$t('common.new_pwd_label')"
      prop="newPwd"
    >
      <el-input
        type="password"
        onpaste="return false"
        oncontextmenu="return false"
        oncopy="return false"
        oncut="return false"
        v-model="form.newPwd"
      ></el-input>
    </el-form-item>
    <el-form-item style="margin-bottom: 0;">
      <ul
        class="pwd-strength"
        v-show="form.newPwd"
        :class="{'hidden':!form.newPwd}"
      >
        <li
          class="strength-item"
          :class="{risk: pwdStrengthLv === 0,error:pwdStrengthLv === 1, warn: pwdStrengthLv === 2, normal: pwdStrengthLv === 3}"
        ></li>
        <li
          class="strength-item"
          :class="{error: pwdStrengthLv === 1, warn: pwdStrengthLv === 2, normal: pwdStrengthLv === 3}"
        ></li>
        <li
          class="strength-item"
          :class="{warn: pwdStrengthLv === 2, normal: pwdStrengthLv === 3}"
        ></li>
        <li
          class="strength-item"
          :class="{normal: pwdStrengthLv === 3}"
        ></li>
        <li
          class="strength-name error"
          v-if="pwdStrengthLv === 0"
        >{{$t('common.pwd_strength_1')}}</li>
        <li
          class="strength-name warn"
          v-if="pwdStrengthLv === 1"
        >{{$t('common.pwd_strength_2')}}</li>
        <li
          class="strength-name normal"
          v-if="pwdStrengthLv === 2"
        >{{$t('common.pwd_strength_3')}}</li>
        <li
          class="strength-name normal"
          v-if="pwdStrengthLv === 3"
        >{{$t('common.pwd_strength_4')}}</li>
      </ul>
    </el-form-item>
    <el-form-item
      :label="$t('common.confirm_pwd_label')"
      prop="confirmPwd"
    >
      <el-input
        type="password"
        onpaste="return false"
        oncontextmenu="return false"
        oncopy="return false"
        oncut="return false"
        v-model="form.confirmPwd"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { requireRule, min8Max20ChartRule, noChinese } from 'utils/validator'
import Api from 'api/api'
import { ErrorHandleMixin } from 'utils/mixin'

export default {
  name: 'modify-password-form',
  props: {
    showOldPwd: Boolean
  },
  data () {
    return {
      form: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      rules: {
        oldPwd: [requireRule, min8Max20ChartRule, noChinese],
        newPwd: [
          requireRule, min8Max20ChartRule, noChinese,
          {
            validator: (rule, value, callback) => {
              let _len = 0
              if (value.length < 8) {
                callback(new Error(this.$t('common.new_pwd_error')))
              } else {
                _len = 0
                let standard1 = !!value.match(/[a-z]/g)
                let standard2 = !!value.match(/[A-Z]/g)
                let standard3 = !!value.match(/[0-9]/g)
                let standard4 = !!value.match(/(.[^a-z0-9])/g)
                let _arr = [standard1, standard2, standard3, standard4]
                _arr.forEach(item => {
                  if (item) {
                    _len++
                  }
                })
                if (_len < 2) {
                  callback(new Error(this.$t('common.new_pwd_error')))
                }
              }
              callback()
            },
            trigger: 'blur'
          }, {
            validator: (rule, value, callback) => {
              if (value === this.form.oldPwd) {
                callback(new Error('新密码不能与旧密码相同'))
              }
              callback()
            },
            trigger: 'blur'
          }, {
            validator: (rule, value, callback) => {
              if (value === this.userName || value === this.userName.split('').reverse().join('')) {
                callback(new Error('不能与用户名或者用户名的倒写相同'))
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        confirmPwd: [
          requireRule, min8Max20ChartRule, noChinese,
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.newPwd) {
                callback(new Error(this.$t('common.confirm_pwd_error')))
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      },
      userName: null,
      passwordIcon: 'h-icon-password_unvisible',
      passwordType: 'password'
    }
  },
  mixins: [ErrorHandleMixin],
  mounted () {
    this._getBasicInfo()
  },
  computed: {
    pwdStrengthLv () {
      let iRank = 0
      let szUser = this.userName
      let szPwd = this.form.newPwd
      let standard1 = !!szPwd.match(/[a-z]/g)
      let standard2 = !!szPwd.match(/[A-Z]/g)
      let standard3 = !!szPwd.match(/[0-9]/g)
      let standard4 = !!szPwd.match(/[^a-zA-Z0-9]/g)
      let _arr = [standard1, standard2, standard3, standard4]
      let _len = 0
      _arr.forEach(item => {
        if (item) {
          _len++
        }
      })
      if (szPwd.length < 8 || _len < 2 || szPwd === szUser || (szUser !== null && szPwd === szUser.split('').reverse().join(''))) {
        iRank = 0
      } else if (szPwd.length >= 8 && _len === 2 && ((standard1 && standard3) || (standard2 && standard3))) {
        iRank = 1
      } else if (szPwd.length >= 8 && _len === 2 && (!(standard1 && standard3) || !(standard2 && standard3))) {
        iRank = 2
      } else if (_len > 2) {
        iRank = 3
      }
      return iRank
    }
  },
  methods: {
    onMousedownClick (ev) {
      this.passwordType = 'text'
      this.passwordIcon = 'h-icon-password_visible'
      document.onmouseup = () => {
        this.passwordType = 'password'
        this.passwordIcon = 'h-icon-password_unvisible'
      }
    },
    onMouseupClick (ev) {
      this.passwordType = 'password'
      this.passwordIcon = 'h-icon-password_unvisible'
    },
    getData () {
      let _res
      this.$refs.form.validate(valid => {
        if (valid) {
          _res = {
            newPassword: this.form.newPwd,
            newPasswordConfirm: this.form.confirmPwd,
            oldPassword: this.form.oldPwd
          }
        } else {
          _res = false
        }
      })
      return _res
    },
    reset () {
      this.$refs.form.resetFields()
    },
    _getBasicInfo () {
      Api.common
        .basicInfo()
        .then(res => {
          this.userName = res.data.userName || ''
        })
        .catch(this._handleError)
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
/* modify-password-form.less */
@font-size: 12px;
@nav-bg-1: #e5e5e5;
@font-color-risk: #fa3239;
@font-color-danger: #ff952c;
@font-color-warn: #ffcc00;
@font-color-normal: #02bf0f;
.m-form {
  user-select: none;
}
/deep/ .el-input__inner::-ms-reveal {
  display: none;
}
.pwd-strength {
  .strength-item {
    background-color: @nav-bg-1;
    &.risk {
      background-color: @font-color-risk;
    }
    &.error {
      background-color: @font-color-danger;
    }
    &.warn {
      background-color: @font-color-warn;
    }
    &.normal {
      background-color: @font-color-normal;
    }
  }
  .strength-name {
    font-size: @font-size;
    &.risk {
      color: @font-color-risk;
    }
    &.error {
      color: @font-color-danger;
    }
    &.warn {
      color: @font-color-warn;
    }
    &.normal {
      color: @font-color-normal;
    }
  }
  &.hidden {
    opacity: 0;
  }
}
.pwd-strength {
  font-size: 0;
  padding: 0;
  margin: 0;
  .strength-item {
    display: inline-block;
    width: 65px;
    height: 5px;
    margin-right: 2px;
  }
  .strength-name {
    display: inline-block;
    margin-left: 15px;
  }
}
</style>
